// @fflow
import moment from 'moment';
import { handleActions } from 'redux-actions';

import DATE_FORMAT from 'constants/date';
import { fetchGraphql, download } from '../utils/ajax';

import { mapArrayToTsvString } from '../utils/toTsvString';
import { buildReportMap } from './reportsHelpers';

export const REPORTS_REQUEST = 'gdc/REPORTS_REQUEST';
export const REPORTS_SUCCESS = 'gdc/REPORTS_SUCCESS';
export const REPORTS_FAILURE = 'gdc/REPORTS_FAILURE';

function queryReports({
  reportType, projects,
}) {
  return {
    variables: {
      projectIds: projects,
      reportType: reportType || null,
      first: 2 * projects.length,
    },
    query: `
      query ReportsQuery(
        $first: Int
        $reportType: String
        $projectIds: [String]
      ) {
        items: gdc_report(
          first: $first
          project_id: $projectIds
          report_type: $reportType
          order_by_desc: "created_datetime"
        ) {
          id
          report_type
          report
          project_id
          created_datetime
        }
      }
    `,
  };
}

export const fetchReports = (variables, meta) => (
  fetchGraphql(
    [
      REPORTS_REQUEST,
      {
        type: REPORTS_SUCCESS,
        meta: { ...meta, reportType: variables.reportType },
      },
      REPORTS_FAILURE,
    ],
    queryReports(variables),
  )
);

const initialState = {
  isFetching: false,
  reportsByDate: {},
};

export default handleActions({
  [REPORTS_REQUEST]: state => ({
    ...state,
    isFetching: true,
  }),
  [REPORTS_SUCCESS]: (state, action) => {
    // Create a dictionary in the following format:
    // {
    //    millisecs_date1: [reportMap1, reportMap2, ...]
    //    millisecs_date2: [reportMap1, reportMap2, ...]
    // }
    const reportsByDate = action.payload.data.items.reduce((acc, val) => {
      const date = +moment(val.created_datetime);

      return {
        ...acc,
        [date]: [
          ...(acc[date] || []),
          buildReportMap({ report: JSON.parse(val.report), type: action.meta.reportType }),
        ],
      };
    }, {});


    if ((action.meta || {}).download) {
      const latestReportDate = Math.max(...Object.keys(reportsByDate));
      const reportsByProject = {};
      // Create a helper dictionary in the following format:
      // {
      //    project_id1: reportMap1,
      //    project_id2: reportMap2,
      //    ...
      // }
      // We iterate through reportsByDate in chronological order, so latest
      // project's reports will be assigned last.
      Object.keys(reportsByDate).sort().forEach((date) => {
        reportsByDate[date].forEach((mapping) => {
          const project_id = `${mapping.get('Program')}-${mapping.get('Project')}`;
          reportsByProject[project_id] = mapping;
        });
      });

      const latestReport = Object.values(reportsByProject);
      if (latestReport && latestReport.length) {
        download(
          mapArrayToTsvString(latestReport),
          'TSV',
          `${action.meta.reportType}_${moment(latestReportDate).format(DATE_FORMAT)}.tsv`,
        );
      } else {
        download(JSON.stringify({ message: 'This report has no entries' }), 'JSON', 'empty.json');
      }
    }

    return {
      isFetching: false,
      reportsByDate,
    };
  },
  [REPORTS_FAILURE]: state => ({
    ...state,
    isFetching: false,
  }),
}, initialState);
